export default "__VITE_ASSET__fp8_FB94__"